import CommentThread from "./commentThread.component";

export default CommentThread;
